import React from 'react';
import SideBarMobile from '../../../shared/templates/CategoryTemplate/category-sidebar-mobile';

function JobsSideBarMobile(props) {
  return (<SideBarMobile {...props}
    section="jobs"
    searchTitle="Search Jobs"
    createNewTitle="New Job"
    filterList={[
      { name: 'keywords', value: 'Enter Keywords' },
    ]}
  />);
}

export default JobsSideBarMobile;